var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v("Deleting levy collection, please wait...")])])
}]

export { render, staticRenderFns }